<script>
export default {
  name: 'ProductSearchModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'insertProduct'],
  methods: {
    close() {
      this.$emit('close');
    },
    handleMessage(event) {
      if (event.data && event.data.event === 'insert-message') {
        this.$emit('insertProduct', event.data.message);
        this.close();
      }
    },
  },
  mounted() {
    window.addEventListener('message', this.handleMessage);
  },
  beforeUnmount() {
    window.removeEventListener('message', this.handleMessage);
  },
};
</script>

<template>
  <transition name="modal-fade">
    <div
      v-if="show"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      @click.self="close"
    >
      <div
        class="bg-white dark:bg-slate-900 rounded-lg shadow-xl w-full max-w-2xl h-[600px] flex flex-col"
      >
        <div
          class="flex items-center justify-between p-4 border-b border-slate-200 dark:border-slate-700"
        >
          <h3 class="text-lg font-semibold text-slate-900 dark:text-white">
            🛍️ Consulta de Produtos
          </h3>
          <button
            class="text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200"
            @click="close"
          >
            <fluent-icon icon="dismiss" size="20" />
          </button>
        </div>
        <div class="flex-1 overflow-hidden">
          <iframe
            src="https://chat.purimax.net/products-app/inline.html"
            class="w-full h-full border-0"
            title="Consulta de Produtos"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}
</style>
